export interface PurchaseOrderValidationResponseV4 {
  purchaseOrderCode: string;
  isValid: boolean;
}
